module.exports = __webpack_public_path__ + "4b292aab2c877a97edbc30aedcbca6ad.png";